import * as Sentry from '@sentry/react'
import {
  browserTracingIntegration,
  captureConsoleIntegration,
  extraErrorDataIntegration,
  httpClientIntegration,
} from '@sentry/browser'

export const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,

    integrations: [
      browserTracingIntegration(),
      captureConsoleIntegration({ levels: ["error"] }),
      extraErrorDataIntegration(),
      httpClientIntegration({
        failedRequestStatusCodes: [400, 403, 404, 500, 503, 599]
      }),
    ],

    environment: process.env.HEROKU_APP_NAME || "development",

    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    ignoreErrors: [
      "NetworkError",
      "ResizeObserver loop limit exceeded",
      "ChunkLoadError",
      "Non-Error promise rejection captured",
      "Failed to fetch"
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],

    beforeBreadcrumb(breadcrumb) {
      if (["http", "console"].includes(breadcrumb.category)) return null;
      return breadcrumb;
    },

    beforeSend(event) {
      if (event.user) {
        delete event.user.ip_address;
        delete event.user.email;
      }
      return event;
    },

    sendDefaultPii: false,
  });
};
